<template>
  <v-form ref="mainForm" v-model="valid">
    <CatalogueLive
      code="ordre_ouinon"
      v-model="sas.sasEquivalence.desireAjouterOrdresProfessionnels"
      :live="{ endpoint: 'sas-equivalence', cle: '6149', fileId: sas.sasEquivalence.id }"
    />
    <data-iterator
      :list="sas.sasMembreAutreOrdre"
      add-new-text="Ajouter un ordre professionnel"
      :live="{ endpoint: 'sas-membre-autre-ordre', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
      :opq-if="estOui(sas.sasEquivalence.desireAjouterOrdresProfessionnels)"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.nom }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="ordre_nom" v-model="item.nom" :live="liveSasMembreAutreOrdre(6804, item)" />
        <CatalogueLive code="ordre_pays" v-model="item.pays" :live="liveSasMembreAutreOrdre(6802, item)" />
        <CatalogueLive code="ordre_province" v-model="item.province" :live="liveSasMembreAutreOrdre(6803, item)" :opq-if="estCanada(item.pays)" />
        <TextFieldLive code="ordre_numero" v-model="item.nPermis" :live="liveSasMembreAutreOrdre(6805, item)" />
        <DatePickerLive
          code="ordre_debut"
          v-model="item.dateDeDebut"
          :live="liveSasMembreAutreOrdre(6807, item)"
          :maxValue="convertDateToString(new Date())"
        />
        <DatePickerLive
          code="ordre_fin"
          v-model="item.dateDeFin"
          :live="liveSasMembreAutreOrdre(6808, item)"
          :maxValue="convertDateToString(new Date())"
        />
        <FileInput code="ordre_preuve" :file="item.preuve" :live="liveSasMembreAutreOrdre(6806, item)" />
        <FileInput code="ordre_lettre" :file="item.attestationDeMembre" :live="liveSasMembreAutreOrdre(6809, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasMembreAutreOrdre(cle, item) {
      return { endpoint: "sas-membre-autre-ordre", cle: cle, fileId: item.id }
    },
    estCanada(pays) {
      return this.getCatalogueCodeById("303", pays) == "CA"
    }
  }
}
</script>

<style></style>
